import { createElement } from "react";
import React from "react";
import * as react from "react";
import Home from "@mui/icons-material/Home";
import DirectionsBoat from "@mui/icons-material/DirectionsBoat";
import Room from "@mui/icons-material/Room";
import Timeline from "@mui/icons-material/Timeline";
import { map, append } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import Settings from "@mui/icons-material/Settings";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { globalCtx } from "./Context.js";
import { isBig as isBig_1 } from "./Utils.js";
import { Role, Role__get_Identifier } from "./Shared/Shared.js";
import { contains, singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { empty, singleton, append as append_1, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { stringHash, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Button, Portal, Toolbar, CssBaseline, IconButton, AppBar, Drawer, ListItemText, Typography, Icon, ListItem, List } from "@mui/material";
import Feedback from "@mui/icons-material/Feedback";
import ExitToApp from "@mui/icons-material/ExitToApp";
import Menu from "@mui/icons-material/Menu";

function getNavigationItems(isSuperOrCompanyAdmin) {
    let props_1, props_3, props_5, props_7, props_9;
    const navigationItems = [["favorites", "Forside", (props_1 = {}, react.createElement(Home, props_1))], ["vessels", "Fartøy", (props_3 = {}, react.createElement(DirectionsBoat, props_3))], ["routes", "Samband", (props_5 = {}, react.createElement(Room, props_5))], ["timeline", "Tidslinje", (props_7 = {}, react.createElement(Timeline, props_7))]];
    if (isSuperOrCompanyAdmin) {
        return append(navigationItems, [["admin", "Admin", (props_9 = {}, react.createElement(Settings, props_9))]]);
    }
    else {
        return navigationItems;
    }
}

export function SideNavigation() {
    const ctx = reactApi.useContext(globalCtx);
    const patternInput = reactApi.useState(false);
    const sideBarOpen = patternInput[0];
    const setSideBarOpen = patternInput[1];
    const isBig = isBig_1(ctx.Responsive);
    let isAdminOrHasAdminRole;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        isAdminOrHasAdminRole = (s.IsSuperAdmin ? true : s.Roles.some((r) => (r.RoleId === Role__get_Identifier(new Role(6, [])))));
    }
    else {
        isAdminOrHasAdminRole = false;
    }
    const itemPadding = ofArray([["paddingLeft", 32], ["paddingTop", 16], ["paddingBottom", 16], ["paddingRight", 16]]);
    const drawerContent = (includeLogo) => toList(delay(() => {
        let elems_2;
        return append_1(includeLogo ? singleton(createElement("a", createObj(ofArray([["href", RouterModule_encodeParts(singleton_1("favorites"), 1)], ["style", {
            cursor: "pointer",
        }], (elems_2 = [createElement("img", {
            src: "/images/TH_Logo.png",
            style: {
                height: "auto",
                width: 100 + "%",
                padding: ((1 + "rem") + " ") + (2 + "rem"),
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty(), delay(() => {
            let elems_12, elems_7, elems_11;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: 100 + "%",
            }], (elems_12 = [MuiHelpers_createElement(List, [["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems_7 = toList(delay(() => {
                const matchValue_1 = ctx.Session;
                if (matchValue_1 != null) {
                    const x_1 = matchValue_1;
                    return singleton(map((tupledArg) => {
                        let elements;
                        const url = tupledArg[0];
                        return MuiHelpers_createElement(ListItem, [["alignItems", "center"], ["component", "a"], ["button", true], ["selected", contains(url, ctx.CurrentPath, {
                            Equals: (x, y) => (x === y),
                            GetHashCode: stringHash,
                        })], ["style", createObj(toList(delay(() => itemPadding)))], ["href", RouterModule_encodeParts(singleton_1(url), 1)], ["onClick", (_arg_1) => {
                            setSideBarOpen(false);
                        }], (elements = [MuiHelpers_createElement(Icon, [["style", {
                            textAlign: "center",
                        }], ["children", reactApi.Children.toArray([tupledArg[2]])]]), MuiHelpers_createElement(Typography, [["children", tupledArg[1]], ["style", {
                            marginLeft: 5,
                        }]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
                    }, getNavigationItems(isAdminOrHasAdminRole)));
                }
                else {
                    return empty();
                }
            })), ["children", reactApi.Children.toArray(Array.from(elems_7))])]), MuiHelpers_createElement(List, [["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems_11 = toList(delay(() => {
                let elements_4, children_4, props_16;
                const matchValue_2 = ctx.Session;
                if (matchValue_2 != null) {
                    const x_2 = matchValue_2;
                    return append_1(singleton(MuiHelpers_createElement(ListItem, [["alignItems", "center"], ["component", "a"], ["button", true], ["style", createObj(itemPadding)], ["href", RouterModule_encodeParts(singleton_1("feedback"), 1)], ["onClick", (_arg_3) => {
                        setSideBarOpen(false);
                    }], (elements_4 = [(children_4 = singleton_1((props_16 = {}, react.createElement(Feedback, props_16))), MuiHelpers_createElement(Icon, [["children", reactApi.Children.toArray(Array.from(children_4))]])), MuiHelpers_createElement(Typography, [["children", "Tilbakemelding"], ["style", {
                        marginLeft: 5,
                    }]])], ["children", reactApi.Children.toArray(Array.from(elements_4))])])), delay(() => {
                        let elements_2, children_2, props_11;
                        return append_1(singleton(MuiHelpers_createElement(ListItem, [["alignItems", "center"], ["component", "a"], ["button", true], ["style", createObj(itemPadding)], ["href", "/api/auth/signout"], ["onClick", (_arg_2) => {
                            setSideBarOpen(false);
                        }], (elements_2 = [(children_2 = singleton_1((props_11 = {}, react.createElement(ExitToApp, props_11))), MuiHelpers_createElement(Icon, [["children", reactApi.Children.toArray(Array.from(children_2))]])), MuiHelpers_createElement(Typography, [["children", "Logg ut"], ["style", {
                            marginLeft: 5,
                        }]])], ["children", reactApi.Children.toArray(Array.from(elements_2))])])), delay(() => {
                            let elements_5;
                            return singleton(MuiHelpers_createElement(ListItem, [["style", createObj(toList(delay(() => itemPadding)))], ["dense", true], (elements_5 = [MuiHelpers_createElement(ListItemText, [["primary", x_2.AppVersion], ["secondary", "av Serit Tromsø"]])], ["children", reactApi.Children.toArray(Array.from(elements_5))])]));
                        }));
                    }));
                }
                else {
                    return empty();
                }
            })), ["children", reactApi.Children.toArray(Array.from(elems_11))])])], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
        }));
    }));
    const children_5 = toList(delay(() => {
        let elements_6, elems_14, elems, props_1, elems_1;
        return isBig ? singleton(MuiHelpers_createElement(Drawer, [["style", {
            display: "block",
            zIndex: 1,
        }], ["variant", "permanent"], ["open", true], ["anchor", "left"], ["PaperProps", {
            style: {
                width: 200,
            },
        }], (elements_6 = drawerContent(true), ["children", reactApi.Children.toArray(Array.from(elements_6))])])) : append_1(singleton(MuiHelpers_createElement(AppBar, [["variant", "outlined"], ["position", "static"], ["style", {
            backgroundColor: "#FFFFFF",
            height: 64,
            position: "fixed",
            flexDirection: "row",
            paddingRight: 10,
            paddingLeft: 10,
            justifyContent: "center",
            alignItems: "center",
        }], (elems_14 = [MuiHelpers_createElement(IconButton, [["style", {
            width: 3 + "rem",
            height: 3 + "rem",
        }], ["onClick", (_arg) => {
            setSideBarOpen(!sideBarOpen);
        }], ["color", "primary"], (elems = [(props_1 = {}, react.createElement(Menu, props_1))], ["children", reactApi.Children.toArray(Array.from(elems))])]), createElement("a", createObj(ofArray([["style", {
            marginLeft: "auto",
            marginRight: "auto",
        }], ["href", RouterModule_encodeParts(singleton_1("favorites"), 1)], (elems_1 = [createElement("img", {
            src: "/images/Torghatten_slim.jpg",
            style: {
                height: 2.5 + "rem",
                padding: 0.25 + "rem",
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("span", {
            style: {
                flexGrow: 1,
                maxWidth: 3 + "rem",
                minWidth: 0,
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_14))])])), delay(() => {
            let elements_7;
            return singleton(MuiHelpers_createElement(Drawer, [["style", {
                display: "block",
                zIndex: 1500,
            }], ["ModalProps", {
                keepMounted: true,
            }], ["variant", "temporary"], ["onClose", (_arg_4) => {
                setSideBarOpen(false);
            }], ["open", sideBarOpen], ["anchor", "left"], ["PaperProps", {
                style: {
                    boxSizing: "border-box",
                    width: 200,
                    paddingTop: 64,
                },
            }], (elements_7 = drawerContent(false), ["children", reactApi.Children.toArray(Array.from(elements_7))])]));
        }));
    }));
    return MuiHelpers_createElement(CssBaseline, [["children", reactApi.Children.toArray(Array.from(children_5))]]);
}

export function LogoNavbar() {
    let elements_5, elems_7, elements_7, elems_13, children_5, elems_1, elems_12;
    const ctx = reactApi.useContext(globalCtx);
    const patternInput = reactApi.useState(false);
    const sideBarOpen = patternInput[0];
    const setSideBarOpen = patternInput[1];
    const isBig = isBig_1(ctx.Responsive);
    let isAdminOrHasAdminRole;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        isAdminOrHasAdminRole = (s.IsSuperAdmin ? true : s.Roles.some((r) => (r.RoleId === Role__get_Identifier(new Role(6, [])))));
    }
    else {
        isAdminOrHasAdminRole = false;
    }
    const responsiveSideDrawer = MuiHelpers_createElement(Drawer, [["style", {
        minWidth: 200,
        display: "flex",
        flexGrow: 0,
        flexShrink: 0,
        zIndex: 1,
    }], ["variant", "temporary"], ["onClose", (_arg_2) => {
        setSideBarOpen(false);
    }], ["open", sideBarOpen], ["anchor", "left"], ["PaperProps", {
        style: {
            minWidth: 200,
        },
    }], (elements_5 = [MuiHelpers_createElement(List, [["style", {
        marginTop: 4 + "rem",
        display: "flex",
        flexDirection: "column",
        height: 100 + "%",
    }], (elems_7 = toList(delay(() => {
        const matchValue_1 = ctx.Session;
        if (matchValue_1 != null) {
            const x_2 = matchValue_1;
            return append_1(singleton(map((tupledArg_1) => {
                let elements_1;
                const url_1 = tupledArg_1[0];
                return MuiHelpers_createElement(ListItem, [["component", "a"], ["button", true], ["selected", contains(url_1, ctx.CurrentPath, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: stringHash,
                })], ["href", RouterModule_encodeParts(singleton_1(url_1), 1)], ["onClick", (_arg_1) => {
                    setSideBarOpen(false);
                }], (elements_1 = [MuiHelpers_createElement(Icon, [["children", reactApi.Children.toArray([tupledArg_1[2]])]]), MuiHelpers_createElement(Typography, [["children", tupledArg_1[1]], ["style", {
                    marginLeft: 5,
                }]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
            }, getNavigationItems(isAdminOrHasAdminRole))), delay(() => {
                let elements_3, children_4, props_12;
                return append_1(singleton(MuiHelpers_createElement(ListItem, [["button", true], ["style", {
                    marginTop: "auto",
                }], ["href", "/api/auth/signout"], (elements_3 = [(children_4 = singleton_1((props_12 = {}, react.createElement(ExitToApp, props_12))), MuiHelpers_createElement(Icon, [["children", reactApi.Children.toArray(Array.from(children_4))]])), MuiHelpers_createElement(Typography, [["children", "Logg ut"], ["style", {
                    marginLeft: 5,
                }]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])), delay(() => {
                    let elements_4;
                    return singleton(MuiHelpers_createElement(ListItem, [["dense", true], (elements_4 = [MuiHelpers_createElement(ListItemText, [["primary", x_2.AppVersion], ["secondary", "av Serit Tromsø"]])], ["children", reactApi.Children.toArray(Array.from(elements_4))])]));
                }));
            }));
        }
        else {
            return empty();
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])]);
    const children_6 = singleton_1(MuiHelpers_createElement(AppBar, [["position", "static"], ["style", {
        borderColor: "#FFFFFF",
        height: 4 + "rem",
        position: "fixed",
    }], (elements_7 = [MuiHelpers_createElement(Toolbar, [["style", createObj(toList(delay(() => append_1(singleton(["color", "#FFFFFF"]), delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["height", 4 + "rem"]), delay(() => (!isBig ? singleton(["justifyContent", "space-between"]) : empty()))))))))))], (elems_13 = [(children_5 = toList(delay(() => (!isBig ? singleton(responsiveSideDrawer) : empty()))), MuiHelpers_createElement(Portal, [["children", reactApi.Children.toArray(Array.from(children_5))]])), createElement("a", createObj(ofArray([["href", RouterModule_encodeParts(singleton_1("favorites"), 1)], ["style", {
        cursor: "pointer",
    }], (elems_1 = [createElement("img", {
        src: "/images/Torghatten_logo_only256.png",
        style: {
            height: 4 + "rem",
            padding: 0.25 + "rem",
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["gap", 10 + "px "]), delay(() => (isBig ? append_1(singleton(["marginLeft", 200 - 80]), delay(() => append_1(singleton(["width", 100 + "%"]), delay(() => singleton(["justifyContent", "space-between"]))))) : empty()))))))))], (elems_12 = toList(delay(() => {
        let matchValue_2, x_3, elems_10;
        return append_1(isBig ? ((matchValue_2 = ctx.Session, (matchValue_2 != null) ? ((x_3 = matchValue_2, append_1(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            gap: 10 + "px ",
        }], (elems_10 = [map((tupledArg) => {
            const url = tupledArg[0];
            return MuiHelpers_createElement(Button, [["variant", "text"], ["style", createObj(toList(delay(() => append_1(singleton(["color", "#FFFFFF"]), delay(() => (contains(url, ctx.CurrentPath, {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            }) ? singleton(["backgroundColor", "rgba(255,255,255,0.2)"]) : empty()))))))], ["children", tupledArg[1]], ["startIcon", tupledArg[2]], ["href", RouterModule_encodeParts(singleton_1(url), 1)]]);
        }, getNavigationItems(isAdminOrHasAdminRole))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => {
            let elems_11, props_7;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
            }], (elems_11 = [MuiHelpers_createElement(Typography, [["style", {
                marginRight: 10,
            }], ["variant", "body1"], ["children", x_3.AppVersion]]), MuiHelpers_createElement(Button, [["variant", "text"], ["style", {
                color: "#FFFFFF",
            }], ["children", "Logg ut"], ["startIcon", (props_7 = {}, react.createElement(ExitToApp, props_7))], ["href", "/api/auth/signout"]])], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
        })))) : (empty()))) : empty(), delay(() => {
            let elems, props_1;
            return !isBig ? singleton(MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
                setSideBarOpen(!sideBarOpen);
            }], ["color", "inherit"], (elems = [(props_1 = {}, react.createElement(Menu, props_1))], ["children", reactApi.Children.toArray(Array.from(elems))])])) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])], ["children", reactApi.Children.toArray(Array.from(elements_7))])]));
    return MuiHelpers_createElement(CssBaseline, [["children", reactApi.Children.toArray(Array.from(children_6))]]);
}

//# sourceMappingURL=Navbar.js.map
